import { Link } from '@tanstack/react-router'
import { PremiumSection } from '../shared/PremiumSection'
import { PremiumHeading } from '../shared/PremiumHeading'
import { BOOKING_HREF, INCLUDED, REFUND_POLICY, REVIEW } from '@/content/offer'

export function OfferSection() {
  return (
    <PremiumSection id="offer" containerClassName="max-w-4xl">
      <div className="grid gap-10 md:grid-cols-[1.15fr_0.85fr] md:items-start">
        <div>
          <p className="mb-4 font-mono text-sm text-[#8b958f]">
            The one thing I sell
          </p>
          <PremiumHeading as="h2">
            The Workflow Review — {REVIEW.duration}, 1:1, on your actual work
          </PremiumHeading>
          <p className="mb-6 leading-relaxed text-[#c3ccc7]">
            Bring a codebase, a project you are planning, or an agent setup
            that keeps going wrong. We work on it together on a screen-share —
            I change things while you watch. You leave with a written plan.
          </p>
          <ul className="mb-8 space-y-3">
            {INCLUDED.slice(0, 3).map((item) => (
              <li
                key={item}
                className="flex gap-3 leading-relaxed text-[#c3ccc7]"
              >
                <span
                  aria-hidden="true"
                  className="mt-0.5 shrink-0 font-mono text-sm text-[#8b958f]"
                >
                  +
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <Link
            to="/call"
            className="font-semibold text-[#80cca5] transition-colors hover:text-[#6bb890]"
          >
            Everything it does and does not cover →
          </Link>
        </div>

        <div className="rounded-xl border border-[#232a26] bg-[#141817] p-6">
          <p className="mb-1 text-3xl font-semibold text-[#f0f3f1]">
            {REVIEW.price}
          </p>
          <p className="mb-5 text-sm text-[#8b958f]">
            one session · {REVIEW.duration} · nothing recurring
          </p>
          <a
            href={BOOKING_HREF}
            className="mb-4 inline-flex w-full justify-center rounded-lg bg-[#80cca5] px-6 py-3 font-semibold text-[#0e1110] transition-colors hover:bg-[#6bb890]"
          >
            Book a Workflow Review
          </a>
          <p className="text-sm leading-relaxed text-[#8b958f]">
            {REFUND_POLICY}
          </p>
        </div>
      </div>
    </PremiumSection>
  )
}
